import OutsideClick from './outside-click';
import Debounce from './debounce'

export default {
    install: (Vue) => {
        Vue.use(Debounce)
        Vue.directive('click-outside', OutsideClick)
    }
    // OutsideClick
}